<template>
    <div>
        <div style="width: 100%;text-align: center;position: relative;">
            <!-- <div id="wx_login_container" ref="wxqrcode" style="display: inline-block;margin-top: 10px;"></div> -->
            <div v-show="status===-99 || status===-22" class="topdiv">
                <div style="width:80%;position: absolute;top:25%;left:50%;transform: translateX(-50%);">{{desc}}</div>
                <Button style="position: absolute;top:50%;left:50%;transform: translateX(-50%);" type="primary" @click="refreshLoginQRCode">点击刷新</Button>
            </div>
            <div v-show="status===-99 || status===-22" class="mask1">
            </div>
            <div>
                <img v-show="status===0 || status===-99 || status===-22" :src="datastr" class="qr-code"></img>
            </div>
            <!-- <Icon v-show="status===20" style="margin-top:10%;" size="64" type="md-alert" color="#ff9900" /> -->
            <img v-show="status===20" style="width:64px;height: 64px;margin-top:10%;" src="../../assets/images/wait.png">
            <Icon v-show="status===21" style="margin-top:10%;" size="64" type="md-checkmark-circle" color="#19be6b" />
            <div style="text-align: center;margin-top: 15px;">{{desc}}</div>
        </div>
        <div style="margin-bottom:10px;display: block;text-align: center;margin-top: 50px;">请及时关注微信公众号“众智云擎税法检索”</div>
        <!--   <scriptLink /> -->
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import store from '../../store/'
// import QRCode from 'qrcodejs2'
import ConstJson from "../../api/common/constjson.js"
let constJ = new ConstJson()
export default {
    name: 'wechatlogin_custom',
    props: {
        modelType: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            identity: '',
            model: '',
            datastr: '',
            isQueryWXState: false,
            status: 0,
            desc: '请使用微信扫描二维码登录',
        }
    },
    components: {
        // 'scriptLink': {
        //     render(createElement) {
        //         return createElement(
        //             'script', {
        //                 attrs: {
        //                     type: 'text/javascript',
        //                     src: 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js',
        //                 },
        //             },
        //         )
        //     }
        // }
    },
    methods: {
        closeQRCode() {
            console.log("close QR code===>")
            var po = {
                identity: this.identity,
                model: this.model,
            }
            if(po&&po.identity==='' || po.model===''){
                return
            }
            constJ.reqCloseQRCode(po).then(res => {
                console.log(res)
                //清空
                this.identity=''
                this.model=''
            })
        },
        refreshLoginQRCode() {
            this.wexinLogin()
        },
        //解析URL,返回URL参数对象
        getUrlkey(url) {
            console.log(url)
            var params = {};
            var urls = url.split("?");
            //console.log('1_分割url:', urls)
            var arr = urls[1].split("&");
            //console.log('2_分割urls[1]:', arr)
            console.log(arr)

            for (var i = 0, l = arr.length; i < l; i++) {

                //去除#号部分
                var a = arr[i].split("=");
                //console.log('3_遍历 arr 并分割后赋值给a:', a[0], a[1])

                //去除值的#号部分
                params[a[0]] = a[1].split('#')[0];
                //console.log('4_a给params对象赋值:', params)
            }
            //console.log('5_结果:', params)
            return params;
        },


        qrCode(url) {
            let qrcode = new QRCode('qrcode', {
                width: 100, //图像宽度
                height: 100, //图像高度
                colorDark: "#000000", //前景色
                colorLight: "#ffffff", //背景色
                typeNumber: 4,
                correctLevel: QRCode.CorrectLevel.L //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
            })

            qrcode.clear() //清除二维码 
            qrcode.makeCode(url) //生成另一个新的二维码
        },
        checkWXState(args) {
            let clock = window.setInterval(() => {
                this.pollingStateCode(args, clock)
            }, 1000)


        },

        processStatus(status,clock) {
            let QRStatus = this.$Tools.getQRStatus()
            if (status === QRStatus.IDENTITYSTATUS_WAITING) {
                //提示等待微信授权，继续轮询
            } else if (status === QRStatus.IDENTITYSTATUS_CANCEL) {
                //提示授权取消

                //关闭轮询
                console.log("提示授权取消,clearInterval...")
                window.clearInterval(clock)

            } else if (status === QRStatus.IDENTITYSTATUS_INVALIDATION) {
                //提示二维码过期

                //关闭轮询
                console.log("提示二维码过期,clearInterval...")
                window.clearInterval(clock)
            } else if (status=== QRStatus.IDENTITYSTATUS_INIT) {
                //提示等待扫码，继续轮询
            } else {
                //未处理的状态值，关闭轮询
                console.log("unknow status=====>" + res.data.status)
                //关闭轮询
                console.log("clearInterval...")
                window.clearInterval(clock)
            }
        },

        pollingStateCode(pamars, clock) {
            let k = this.$Tools.getWxState()
            let QRStatus = this.$Tools.getQRStatus()
            if (!this.isQueryWXState) {
                window.clearInterval(clock)
                return
            }
            var po = {
                identity: pamars.identity,
                model: pamars.model,
            }
            constJ.reqPollingCodeAndState(po).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    if (res.data.model === this.modelType && this.modelType === k.WXLOGIN) {
                        // if (res.data.code !== '' && res.data.state !== '') {
                        this.status = res.data.status //同步状态
                        this.desc = res.data.statusdesc
                        if (res.data.status === QRStatus.IDENTITYSTATUS_APPROVE) {
                            let url_pamars = "?code=" + res.data.code + "&state=" + res.data.state
                            let http_redirct = this.$baseConfig.wxRedirectUrl + url_pamars
                            console.log("clearInterval...")
                            window.clearInterval(clock)
                            console.log("执行微信登录")
                            window.location.replace(http_redirct)
                            return
                        } else {
                            this.processStatus(res.data.status,clock)
                        }

                    } else if (res.data.model === this.modelType && this.modelType === k.WXREG) {
                        this.status = res.data.status //同步状态
                        this.desc = res.data.statusdesc
                        if (res.data.status === QRStatus.IDENTITYSTATUS_APPROVE) {
                            let url_pamars = "?code=" + res.data.code + "&state=" + res.data.state
                            let http_redirct = this.$baseConfig.wxRegRedirectUrl + url_pamars
                            console.log("clearInterval...")
                            window.clearInterval(clock)
                            console.log("执行微信注册")
                            window.location.replace(http_redirct)
                            return
                        } else {
                            this.processStatus(res.data.status,clock)
                        }

                    } else if (res.data.model === this.modelType && this.modelType === k.WXBIND) {
                        this.status = res.data.status //同步状态
                        this.desc = res.data.statusdesc
                        if (res.data.status === QRStatus.IDENTITYSTATUS_APPROVE) {
                            let url_pamars = "?code=" + res.data.code + "&state=" + res.data.state
                            let http_redirct = this.$baseConfig.wxBindRedirectUrl + url_pamars
                            console.log("clearInterval...")
                            window.clearInterval(clock)
                            console.log("执行微信绑定")
                            window.location.replace(http_redirct)
                            return
                        } else {
                            this.processStatus(res.data.status,clock)
                        }

                    } else {
                        console.log("登录状态异常")
                        window.clearInterval(clock)
                        return
                    }
                } else {
                    if (res.rltcode < 0) {
                        // this.$Message.warning(res.rltdesc)
                        window.clearInterval(clock)
                        return
                    } else if (res.rtncode < 0) {
                        // this.$Message.warning(res.rtndesc)
                        window.clearInterval(clock)
                        return
                    }
                }
            })
        },

        getWXUrl() {
            let po = {
                model: this.modelType,
            }

            console.log('getWXQRCode======================>' + this.modelType)
            constJ.reqWXQRcode(po).then(res => {
                console.log(res)

                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.identity = res.data.identity
                        this.model = res.data.model
                        this.datastr = `data:image/png;base64,` + res.data.datastr

                        //开启轮询
                        let params = {
                            model: this.model,
                            identity: this.identity
                        }
                        this.isQueryWXState = true
                        this.checkWXState(params)

                    } else {
                        this.$Message.warning(res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.warning(res.rtndesc)
                    return
                }

                // let urlData = this.getUrlkey(res.item.url)
                // console.log(urlData)
                // var obj = new WxLogin({
                //     self_redirect: false,
                //     id: "wx_login_container",
                //     appid: urlData.appid,
                //     scope: urlData.scope,
                //     redirect_uri: urlData.redirect_uri,
                //     state: urlData.state,
                //     style: "",
                //     href: customeStyle, //"https://test.holywiser.com/pubcss/qr.css", //customeStyle,//
                // });
                // var qrcodeBox = document.getElementById("wx_login_container");
                // var iframes = qrcodeBox.getElementsByTagName("iframe");
                // var ifr = iframes[0]
                // ifr.setAttribute("height", "260px;");
                // ifr.setAttribute("width", "300px");
                //console.log(iframes[0])

            })


            // document.getElementById('qrcode').getElementsByTagName("iframe").width="100px"
            // document.getElementById('qrcode').getElementsByTagName("iframe").height="100px"
            //console.log(document.getElementById('qrcode').getElementsByTagName("iframe")) 
        },
        wexinLogin() {
            console.log('weixin custom login===>')
            //this.isShowQrcode = true
            //this.$refs.qrcode.innerHTML=''
            //document.getElementById('qrcode').innerHTML = ''
            this.getWXUrl()
        },
    }
}
</script>
<style lang="less" scoped>
.qr-code {
    height: 164px;
    width: 164px;
    border: 1px solid #dcdee2;
}

.mask1 {
    width: 164px;
    height: 164px;
    display: block;
    left: 49.5%;
    margin-left: -80px;
    position: absolute;
    background-color: #000;
    opacity: 0.5;
    margin-bottom: 50px;
    text-align: center;
    z-index: 100;
}

.topdiv {
    width: 164px;
    height: 164px;
    display: block;
    left: 49.5%;
    margin-left: -80px;
    position: absolute;
    margin-bottom: 50px;
    text-align: center;
    z-index: 101;
    color: #fff;
    font-size: 16px;
}
</style>